import type { AdIIKycLinkScenario } from "../../../../utils/remitterKycFlow";
import { kycLinkStyles as styles } from "./styles";

export interface AdIIKycLinkPanelProps {
  phone?: string;
  email?: string;
  profileDetails?: any;
  isLinkSentLocally?: boolean;
  loading?: boolean;
  onSendLink: () => void;
  onResendLink: () => void;
  onGenerateNewLink: () => void;
  onCopyLink: (link: string) => void;
  onProceed: () => void;
  isRemitterDetailsIncomplete?: boolean;
}

export type CalloutTone = "success" | "info" | "warn";

export const getKycLinkCopy = ({
  scenario,
  statusLabel,
  profileStatus,
}: {
  scenario: AdIIKycLinkScenario;
  statusLabel: string;
  profileStatus: string;
}) => {
  const generateNewLabel = profileStatus === "cancelled" ? "CANCELLED" : "EXPIRED";

  const badge = {
    not_sent: { label: "NOT SENT", className: styles.badgeMuted },
    link_sent: { label: "LINK SENT", className: styles.badgeSuccess },
    generate_new: { label: generateNewLabel, className: styles.badgeExpired },
    rejected: { label: "REJECTED", className: styles.badgeExpired },
    in_progress: { label: statusLabel, className: styles.badgeInfo },
    approved: { label: "APPROVED", className: styles.badgeSuccess },
  }[scenario];

  const subtitle = {
    not_sent: "The KYC link is sent to the remitter via SMS and Email.",
    link_sent: "The remitter has received the link. You can resend, copy, or move ahead.",
    generate_new:
      profileStatus === "cancelled"
        ? "This KYC was cancelled. Generate a new link and share it again."
        : "The previous link is no longer valid. Generate a new one and share it again.",
    rejected: "KYC was rejected. Generate a new link for the remitter to complete KYC again.",
    in_progress: `Latest KYC status: ${statusLabel}. Continue to remitter details.`,
    approved: "KYC is approved. Continue with the remittance.",
  }[scenario];

  const recipientsLabel = {
    not_sent: "WILL SEND TO",
    link_sent: "SENT TO",
    in_progress: "SENT TO",
    approved: "SENT TO",
    generate_new: "LAST SENT TO",
    rejected: "LAST SENT TO",
  }[scenario];

  return { badge, subtitle, recipientsLabel };
};
